export default {
  title: "Rechnungen",
  areaLivingCount: "Anzahl Wohnfläche",
  areaCommercialCount: "Anzahl Gewerbefläche",
  areaLivingPrice: "Preis Wohnfläche",
  areaCommercialPrice: "Preis Gewerbefläche",
  tenant: "Mieter",
};
